import axios from 'axios'

const NectarWrapper = {
  requestToNectar: (token, url) => {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {
          'Access-Token': token,
          'Content-Type': 'application/json'
        }
      }
      return axios.get(url, config).then(({ data }) => {
        return resolve(data)
      }).catch(err => {
        return reject(err)
      })
    })
  },
  getUsers: (token) => {
    return new Promise((resolve, reject) => {
      return NectarWrapper.requestToNectar(
        token,
        'https://app.nectarcrm.com.br/crm/api/1/user'
      ).then(users => {
        return resolve(users)
      }).catch(err => {
        return reject(err)
      })
    })
  },
  getUserContacts: (token) => {
    return new Promise((resolve, reject) => {
      return NectarWrapper.requestToNectar(
        token,
        'https://app.nectarcrm.com.br/crm/api/1/contatos'
      ).then(contacts => {
        return resolve(contacts.filter(c => c.empresa === false))
      }).catch(err => {
        return reject(err)
      })
    })
  },
  getActiveCallTypes: (token) => {
    return new Promise((resolve, reject) => {
      return NectarWrapper.requestToNectar(
        token,
        'https://app.nectarcrm.com.br/crm/api/1/ligacao/tipos'
      ).then(callTypes => {
        return resolve(callTypes.filter(c => c.ativo === true))
      }).catch(err => {
        return reject(err)
      })
    })
  }
}

export default NectarWrapper



// WEBPACK FOOTER //
// ./src/services/nectar-wrapper.js